// extracted by mini-css-extract-plugin
export default {"dropDownSelected":"drop-down-with-selected_dropDownSelected__M-Lj9","dropBox":"drop-down-with-selected_dropBox__jqhFT","triangle":"drop-down-with-selected_triangle__zQMZY"};